export default function StandingsTable({ rows }) {
  const cols = [["#", "position"], ["Ομάδα", "team_name"], ["Αγ.", "played"], ["Ν", "wins"], ["Η", "losses"], ["Σετ +", "sets_won"], ["Σετ −", "sets_lost"],
    ["Διαφ. Σετ", "set_diff"], ["Πόντοι +", "points_for"], ["Πόντοι −", "points_against"], ["Διαφ. Πόντων", "point_diff"]];
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="standings-table">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-widest text-slate-500 border-b">
            {cols.map(([l]) => <th key={l} className={`py-2 px-2 ${l === "Ομάδα" ? "" : "text-center"}`}>{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.team_id} className={`border-b border-slate-50 ${r.position <= 2 ? "bg-emerald-50/50" : ""}`} data-testid={`standing-${r.team_id}`}>
              {cols.map(([l, k]) => (
                <td key={k} className={`py-2.5 px-2 ${l === "Ομάδα" ? "font-bold text-slate-900" : "text-center tabular-nums"} ${k === "position" ? "font-heading font-black text-ocean" : ""}`}>
                  {k === "set_diff" || k === "point_diff" ? (r[k] > 0 ? `+${r[k]}` : r[k]) : r[k]}
                  {k === "team_name" && r.tied && <span className="ml-2 text-[9px] uppercase tracking-widest text-amber-700" title="Ισοβαθμία">ισοβ.</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-[11px] text-slate-500 mt-3">Κριτήρια: νίκες → βαθμοί αγώνων (νίκη 2 / ήττα 1 / άνευ αγώνος 0) → λόγος σετ → λόγος πόντων → μεταξύ τους αγώνας.</p>
    </div>
  );
}
